import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@moe/oss/ui/select";
import { CharacterService } from "@moe/priv/model/character";
import { cn } from "@moe/priv/utils";
import { useNavigate } from "@tanstack/react-router";
import { Route } from "@web/routes";

const timeFilterOptions = [
  { value: "all", label: "All Time" },
  { value: "day", label: "Last 24h" },
  { value: "week", label: "Past Week" },
  { value: "month", label: "Past Month" },
  { value: "year", label: "Past Year" }
];

interface TimeFilterSelectProps {
  className?: string;
}

/**
 * A React component that renders a time filter select dropdown.
 * When the user selects a time period, navigate with the appropriate search query params to apply the filter.
 */
export function TimeFilterSelect({ className }: TimeFilterSelectProps) {
  const nav = useNavigate({ from: Route.fullPath });
  const { period = "all" } = Route.useSearch();

  const timeFilterChangeHandler = (value: string) => {
    nav({ search: (prev) => ({ ...prev, period: value as CharacterService.Period }) });
  };

  return (
    <Select value={period} onValueChange={timeFilterChangeHandler}>
      <SelectTrigger
        className={cn("text-tx-primary h-full w-fit justify-start border-none bg-transparent px-0", className)}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {timeFilterOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
